// クラシック版のエンジンの定数と設定（2026-10-26、段階 C の2 の 7h）。前は common/js/charat/chibi.js・charat.common.js（読めるソース）にあったもの。
// 値も置く順番も前のまま。ページの chibiConfig（ページがこのファイルより先に置く）で既定値を上書きできる（chibi.config）。
// main.ts がほかの部品を置く前に installConsts を呼ぶ（クラシック版のページは前の chibi.min.js の代わりに、このファイルの入った charat.classic.min.js を読む）
/* eslint-disable @typescript-eslint/no-explicit-any */
type Bag = Record<string, any>;
const w = window as unknown as Bag;
// ページが置く値。synm・iconmode はページの let（window には載らない）なので、前の chibi.js と同じく名前で読む
declare const synm: string | undefined;
declare const iconmode: boolean | undefined;
declare const textmode: string | undefined;
declare const chibiConfig: Bag | undefined;

export function installConsts(): void {
  // ローカルホストの判別（テスト用のメニュー・ヘルプボタンを出す既定）
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === 'charat.me.local';
  // 台詞（吹き出し）のレイヤ名。ページの var textmode（portrait 由来）で渡す。無ければ ""（前の chibi.js の var textmode と同じく window にも置く）
  let textmodeValue = typeof textmode !== 'undefined' ? textmode : undefined;
  if (!textmodeValue) {
    textmodeValue = '';
    w.textmode = '';
  }

  w.chibi = w.chibi || {};
  const c = w.chibi as Bag;

  // ---- メーカーごとの設定（2026-10 統一作業で追加） ----
  // ページ側で、このファイルより前に var chibiConfig = { 定数名: 値, ... } を宣言すると、下で chibi.config() を通している定数の既定値を上書きできる。
  // 既定値は、このエンジンを最初から使っている genesis2・dressup2・kawaii・kawaii2 の値（chibiConfig が無ければ今までどおり）。
  c.config = function (aKey: string, aDefault: unknown): unknown {
    if (typeof chibiConfig !== 'undefined' && chibiConfig && chibiConfig[aKey] !== undefined) {
      return chibiConfig[aKey];
    }
    return aDefault;
  };
  // 前任者がメーカー専用に足した後処理（インナー非表示・アイシャドウ・目パチ・肌色連動など）を使うか。
  // chibiConfig.HOOKS = false ですべて止める。{ adjustSVGColors: false, ... } で個別に止める。既定はすべて使う
  c.hook = function (aName: string): boolean {
    const hooks = c.config('HOOKS', true);
    if (hooks === false) {
      return false;
    }
    return !(hooks && typeof hooks === 'object' && hooks[aName] === false);
  };
  const config = (aKey: string, aDefault: unknown): any => c.config(aKey, aDefault);

  // サービス情報
  // SERVICE_NAME は保存キー（localStorage の {名}_save・{名}_auto、IndexedDB の {名}_cache など）。
  // 旧メーカーの多くはディレクトリ名と違う名前（genesis は "gene" など）なので、載せるときは旧値を渡すこと。変えると保存キャラが読めなくなる
  c.SERVICE_NAME = config('SERVICE_NAME', typeof synm !== 'undefined' ? synm : '');
  c.SERVICE_SYNM = config('SERVICE_SYNM', typeof synm !== 'undefined' ? synm : '');
  // 完成画面の小さい画像（#chaMakeResultImageShare。お披露目で送る）の大きさ
  c.SHARE_IMGRATE = 0.4;
  // 情報取得
  c.URI_GETCATEGORY = './getcategory.php';
  c.URI_GETPARTS = './getparts.php';
  c.URI_LOADSVG = './loadsvg.php';
  c.URI_TOP = '../';
  // UI のボタン画像（switch/・icon_left/・ico_right/）の置き場所とキャッシュ避けの番号。旧メーカーは自前の "../img/"
  c.SVG_FILE_KEY = config('SVG_FILE_KEY', '?9');
  c.PATH_IMG = config('PATH_IMG', '/common/img/');
  c.FILE_CHECK = c.PATH_IMG + 'switch/bt_check.svg' + c.SVG_FILE_KEY;
  // 名前（FONT_NAME）とコピーライト（FONT_CR）の書体
  c.FONT_NAME = config('FONT_NAME', 'Makinas');
  c.FONT_CR = config('FONT_CR', 'Makinas');
  c.FONT_NAME_SRC = config('FONT_NAME_SRC', '/common/font/Makinas-Scrap-5.otf');
  c.FONT_CR_SRC = config('FONT_CR_SRC', '/common/font/Makinas-Scrap-5.otf');
  // レイアウト領域
  c.DIV_F_ROOT = '#chaDivRoot';
  c.DIV_F_CONTENTS = '#chaDivCont';
  c.DIV_F_ADS = '#chaDivADS';
  c.DIV_F_ADS_RESULT = '#chaDivADS3';
  c.DIV_F_ADS_MB = '#chaDivADS4';
  c.DIV_F_MAIN = '#chaDivMain';
  c.DIV_F_MAKE = '#chaDivMake';
  c.DIV_F_MAKEMENU = '#chaDivMakeMenu';
  c.DIV_F_EDITMENU = '#chaEditMenu';
  c.DIV_F_OPACITY = '#chaDivOpacity';
  c.DIV_F_ZOOM = '#chaDivZoom';
  c.DIV_F_COLORAREA = '#chaDivColor';
  c.DIV_F_COLOR = '#chaDivSelColor';
  c.DIV_F_COLOR_SC = '#chaDivSelColorScroll';
  c.DIV_F_PICKCOLOR = '#chaDivPickColor';
  c.DIV_F_GRAD = '#chaDivSelGrad';
  c.DIV_F_PATTERNAREA = '#chaDivPattern';
  c.DIV_F_PATTERN = '#chaDivSelPattern';
  c.DIV_F_PATTERN_SC = '#chaDivSelPatternScroll';
  c.DIV_F_PICKPATTERN = '#chaDivPickPattern';
  c.DIV_F_CATEGORY = '#chaDivCategory';
  c.DIV_F_CATEGORY_SC = '#chaDivCategoryScroll';
  c.DIV_F_PARTS = '#chaDivParts';
  c.DIV_F_PARTS_SC = '#chaDivPartsScroll';
  c.DIV_F_SUBMENU = '#chaDivSubMenu';
  c.DIV_F_GROUP_SC = '#chaDivCategoryGroupScroll';
  c.DIV_F_SW_COLOR = 'chaDivSwitchColor';
  c.DIV_F_RESTORE = '#chaDivRestore';
  c.DIV_F_MENU = '#chaDivMenu';
  c.DIV_F_DEBUG = '#chaDivDebug';
  c.INP_F_PICKCOLOR = '#chaInpPickColor';
  c.DIV_F_CIMG = '#chaMakeResultImage';
  c.DIV_F_CIMG_VIEW = '#chaMakeResultImageView';
  c.DIV_F_CIMG_SHARE = '#chaMakeResultImageShare';
  c.DIV_F_MAKE_RESULT = '#chaMakeResult';
  c.DIV_F_MAKE_SHAREB = '#chaMakeResultShareBtn';
  c.DIV_F_MAKE_RSTBG = '#chaMakeResultBg';
  c.DIV_F_MAKE_RSTMES = '#chaMakeResultMessage';
  c.DIV_F_MAKE_RSTINF = '#chaMakeResultInfo';
  // SVG領域
  c.SVG_MAKE = 'chaSvgMake';
  c.SVG_TEXT = 'chaSvgText';
  c.SVG_CLIP = 'chaSvgClip';
  c.SVG_MARKER = 'chaSvgMarker';
  c.SVG_SAVE = 'chaSvgSave';
  c.SVG_BGSAVE = 'chaSvgSaveBG';
  c.SVG_SAVE_DEF = c.SVG_SAVE + ' > defs';
  c.SVG_BGSAVE_DEF = c.SVG_BGSAVE + ' > defs';
  c.SVG_BG = 'chaSvgBG';
  c.SVG_MAKEMENU = 'chaSvgMakeMenu';
  c.SVG_COLOR = 'chaSvgColor';
  c.SVG_PICKCOLOR = 'chaSvgPickColor';
  c.SVG_PATTERN = 'chaSvgPattern';
  c.SVG_GRAD = 'chaSvgGrad';
  c.SVG_CATEGORY = 'chaSvgCategory';
  c.SVG_PARTS = 'chaSvgParts';
  c.SVG_MENU = 'chaSvgMenu';
  c.SVG_EDITMENU = 'chaSvgEMenu';
  // 埋め込み属性など
  c.ATTR_G_ROOT = 'g_root';
  c.ATTR_SELECTED = 'selected';
  c.ATTR_LAYER = 'lcart_';
  c.ATTR_MOVEBUTTON = 'movebutton';
  c.ATTR_GRAD_BAR = 'gbar';
  c.ATTR_GRAD_FROM = 'gfrom';
  c.ATTR_GRAD_TO = 'gto';
  c.ATTR_CCOLOR = 'ccolor';
  c.ATTR_CPATTERN = 'cpattern';
  c.ATTR_CPATTERN_DK = 'cpatterndk';
  c.ATTR_SEL_CHECK = 'selcheck';
  c.ATTR_MENUBUTTON = 'menubutton';
  c.ATTR_RESULTBUTTON = 'resultbutton';
  c.ATTR_EDITFLOATBUTTON = 'efloatbtn';
  c.ATTR_EDITMENUBUTTON = 'emenubtn';
  c.ATTR_EDITSUBBUTTON = 'esubbtn';
  c.ATTR_EDITLISTBUTTON = 'elistbtn';
  c.ATTR_SAVEKEY = c.SERVICE_NAME + '_save';
  c.ATTR_AUTOSAVEKEY = c.SERVICE_NAME + '_auto';
  c.ATTR_SAVEVER = '1.0';
  // キャッシュ用
  c.CACHE_DB = c.SERVICE_NAME + '_cache';
  c.CACHE_DB_VAR = 1;
  c.CACHE_TBL_CHARA = 'charatbl';
  c.CACHE_TBL_CHARA_KEY = 'id';
  c.CACHE_KEY_CHARA = 'chara';
  c.CACHE_KEY_PARTS = 'parts';
  c.CACHE_RELOAD = c.SERVICE_NAME + 'reload';
  c.CACHE_USERID = 'chibiuserid';
  c.CACHE_GLAGREE = c.SERVICE_NAME + '_agree';
  // 特別なレイヤID
  // 背景カテゴリのレイヤ名（背景カテゴリが無いメーカーは ""）
  c.PARTS_BG = config('PARTS_BG', 'bg');
  c.PARTS_CHARA = 'chara';
  // 全体反転の向きの基準にするレイヤ
  c.PARTS_REV = config('PARTS_REV', 'face');
  // 台詞（吹き出し）のレイヤ名。ページ側の textmode でも渡せる（portrait 由来）
  c.PARTS_TEXT = config('PARTS_TEXT', textmodeValue);
  // 選んだときに注意の吹き出しを出すレイヤ
  c.PARTS_TIPS1 = config('PARTS_TIPS1', 'base');
  // 形で切り抜く元のレイヤと、切り抜かれるレイヤ（nyanko3: 頭 head の形でフェイスペイントを切り抜く）。"" なら切り抜かない
  c.PARTS_MASK = config('PARTS_MASK', '');
  c.PARTS_MASKED = config('PARTS_MASKED', []);
  // テキスト
  // 名前を円の縁に沿って描くか（初期値）
  c.MODE_TEXT_ARC = config('MODE_TEXT_ARC', false);
  c.MODE_TEXT = c.PARTS_TEXT != '';
  c.MODE_TEXT_VALID_MIN = config('MODE_TEXT_VALID_MIN', 2);
  c.MODE_TEXT_VALID_MAX = config('MODE_TEXT_VALID_MAX', 15);
  c.MODE_CLIP = false;
  c.MODE_FILTER = config('MODE_FILTER', false);
  c.MODE_RELOAD = true;
  // 柄（パターン）機能を使うか
  c.MODE_PATTERN = config('MODE_PATTERN', true);
  // 柄の描き方の設定（charat.draw.js の patternLine。2026-10-20）。保存データからの描画（読み込み・パーツの差し替え）と新しい作る画面で効く。
  //   PATTERN_PARTS_COLOR: true なら、色を選んでいない柄の地をパーツの元の色に、影の地を色と同じ決まりに（既定 false は柄の灰色のまま。CHOCO の新しい画面は true）
  //   PATTERN_REV_PARTS: false なら、色の入れかえで柄だけ入れかえ、パーツそのものの色は入れかえない（既定 true。CHOCO の新しい画面は false）
  c.PATTERN_PARTS_COLOR = config('PATTERN_PARTS_COLOR', false);
  c.PATTERN_REV_PARTS = config('PATTERN_REV_PARTS', true);
  c.MODE_COLREV = config('MODE_COLREV', 1);
  // 線の太さを変える機能（サブメニューの太く・細くボタン。origin）。変えられるのはカテゴリの IS_SWIDTH が 1 のカテゴリだけ。
  // 使うメーカーは、画面のサブメニューに btnSubThick・btnSubThin を置き、保存データの並び（SAVE_FIELDS）に paramSW を入れる
  c.STROKE_WIDTH = config('STROKE_WIDTH', false);
  // 線の太さの最小・はじめの値・最大
  c.SIZE_WMIN = config('SIZE_WMIN', 0);
  c.SIZE_WORG = config('SIZE_WORG', 3);
  c.SIZE_WMAX = config('SIZE_WMAX', 5);
  // 保存データの1行（"カテゴリ,パーツ,色,…"）のカテゴリより後ろの並び。SAVE_FIELDS_STD は makeCharactor が読む共通の並び。
  // null なら共通の並びの回転・不透明度までを書く（第1世代の旧エンジンは左右色の右To まで。読むときは後ろが無くてもよい）。
  // 並びが違うメーカー（origin は柄モードの後ろが線の太さ）は、今までの保存データが読めるよう、そのメーカーの並びを書く
  // 並びの一覧は charat.draw.js（新しい作る画面と同じもの。2026-10-20）
  c.SAVE_FIELDS_STD = w.charatDraw.SAVE_FIELDS_STD;
  c.SAVE_FIELDS = config('SAVE_FIELDS', null);
  // アイコン系（true）か全身系（false）か。ページ側の iconmode でも渡せる
  c.ICONMODE = config('ICONMODE', typeof iconmode !== 'undefined' ? iconmode : true);
  // カテゴリ・パーツのアイコンの大きさの基準（画面の作りに合わせた値。旧画面は 24・48）
  c.SIZE_CATEGORY_ICON = config('SIZE_CATEGORY_ICON', 16);
  c.SIZE_PARTS_ICON = config('SIZE_PARTS_ICON', 20);
  c.SIZE_PARTS_ROW = 2;
  c.SIZE_CHARAT_IMAGE = 500;
  c.SIZE_CHARAT_BGIMAGE = 750;
  c.SIZE_CATEGORY_IMAGE = 240;
  c.SIZE_COLOR_ICON_W = config('SIZE_COLOR_ICON_W', 32);
  c.SIZE_COLOR_ICON_H = config('SIZE_COLOR_ICON_H', 32);
  c.SIZE_MOVE_ICON_H = 64;
  c.SIZE_COLOR_BAR_W = 30;
  c.SIZE_COLOR_BAR_H = config('SIZE_COLOR_BAR_H', 400);
  c.SIZE_COLOR_PT_W = 58;
  c.SIZE_COLOR_PT_H = 39;
  c.SCALE_MAKE = 1.0;
  c.SCALE_SAVE = 1.0;
  // 完成 PNG の一辺（通常 DL の画質。旧メーカーは 1000、storm は 2000）と、完成 PNG に描く文字の大きさの基準
  c.SIZE_SAVE_PIC = config('SIZE_SAVE_PIC', 500);
  c.SIZE_BASE_PIC = config('SIZE_BASE_PIC', 500);
  c.SIZE_PATTERN = 50;
  c.ADJUST_PATTERN = -94.5;
  // 動作モード
  c.MODE_EDIT = 1;
  c.MODE_VIEW = 2;
  // テーマ色（選択中のボタン・カーソル・背景・パーツ番号の表示色など。メーカーの雰囲気に合わせた値）
  c.COLOR_ACTIVE = config('COLOR_ACTIVE', '#6ADDCB');
  c.COLOR_NONACTIVE = '#3C3C3C';
  c.COLOR_CR = '#333333';
  c.COLOR_NAME = '#333333';
  c.COLOR_NAME_WM = config('COLOR_NAME_WM', '#CCCCCC');
  c.COLOR_BG = config('COLOR_BG', '#F0F0F0');
  c.COLOR_CURSOR = config('COLOR_CURSOR', '#6ADDCB');
  c.COLOR_PID_NAME = config('COLOR_PID_NAME', '#333333');
  c.COLOR_PID_STED = config('COLOR_PID_STED', '#6ADDCB');
  c.COLOR_PID_NORM = config('COLOR_PID_NORM', '#333333');
  c.COLOR_EX1 = '#3f3f3f';
  c.COLOR_EX2 = '#ffffff';
  c.COLOR_STROKE1 = '#666666';
  c.COLOR_STROKE2 = '#c7d9e8';
  // svg領域
  c.svgMake = null;
  c.svgBg = null;
  c.svgMakeMenu = null;
  c.svgEditMenu = null;
  c.svgCategory = null;
  c.svgParts = null;
  c.svgColor = null;
  c.svgPickColor = null;
  c.svgGrad = null;
  c.svgPattern = null;
  c.svgPickPattern = null;
  c.svgMenu = null;
  // スケール
  c.scMake = null;
  c.scCategory = null;
  c.scParts = null;
  c.scColor = null;
  c.scGrad = null;
  // 選択中
  c.allCategory = null;
  c.selCategory = null;
  c.groupCategory = null;
  c.excCategory = null;
  c.selPartsIndex = null;
  c.selLayer = null;
  c.selLayer2 = null;
  c.selLayer3 = null;
  // テスト環境か（テスト用のメニュー・ヘルプボタンを出す）。既定は localhost のとき。旧メーカー（storm 等）は常に false だったので設定で渡す
  c.isTest = config('IS_TEST', isLocalhost);
  c.isMobile = false;
  c.cursorColor = null;
  c.cursorPattern = null;
  c.partsCache = null;
  c.execMode = null;
  c.enableEditColor = false;
  c.enableEditPattern = false;
  c.patternList = null;
  c.pallet = null;
  c.isCompress = true;
  c.charaDef = null;
  c.isViewText = false;
  c.isUseCache = false;
  c.UserID = '';
  c.shareCode = '';
  c.shareKey = '';
  c.tips1 = null;
  c.CompressTime = 0;
  c.selGradPrevCol = '';
  // 完成画面
  c.setMakeCompleteInit = false;
  c.setMakeCompleteLoadOk = false;

  // charat.common の定数と状態（前は charat.common.js。名前の入れ物 charat.common は charat.legacy.js の頭で作る）
  const cm = w.charat.common as Bag;
  cm.SVG_FILL = 'fill';
  cm.SVG_STROKE = 'stroke';
  cm.SVG_SVG = 'svg';
  cm.SVG_G = 'g';
  cm.SVG_MASK = 'svgmask';
  // 作成中
  cm.setNowMakingSrc = null;
  // 入力/確認ダイアログを開く
  cm.openDialogInit = false;
  cm.openDialogOk = null;
  cm.openDialogCancel = null;
  // パーツ入れ替え中
  cm.nowChangeParts = false;
  cm.makeMenuButtonModeSW = 0;
  cm.makeMenuButtonModeSel = 1;
  cm.makeMenuButtonModeReq = 2;
  cm.viewTooltipCount = [];

  installFinishHost(c, cm);
}

// 完成画面の共通部品（common/js/charat/additional.js。ソースは chibi/create/ui/src/finish/*.ts）とのやりとりの窓口（2026-10-24〜、tools/chibi-unify/FINISH-PARTS.md の F2）。
// 新しい作る画面の window.charatCreate.host と同じ形のものを、クラシック版（chibi 系の作る画面・似顔絵くん 1〜11）はここで置く。
// additional.js はエンジン（chibi・charat.common）を直接さわらず、これだけを使う。
//   saveText: 画像に埋め込む圧縮した保存データ、carryText: アプリ内ブラウザから開き直す URL に載せる圧縮データ、font: クレジットの書体、
//   composite: 完成画像を作ったときの背景の SVG と倍率（writeImageFromSVG が覚える）、unzip: 圧縮データ → 保存データの文字、
//   restore: 画像から読んだ保存データでキャラを作り直す（復元パネルを閉じて「作っています」を出す）、closeRestore: 復元パネルを閉じる（エンジンの「復元」ボタンをもう一度押したことにする）、
//   carryIn: アプリ内ブラウザから開き直してきた圧縮データを作りかけ（オートセーブ）に入れる（このあとエンジンの loadDefault が読む）、
//   move・moveEnd: 移動ボタン（#moveup など。選んでいるカテゴリが動かせるときだけ 1 ずつ。離したら輪郭線を付け直す）、isJapanese: シェアの文言の言語（ブラウザの言語）
function installFinishHost(c: Bag, cm: Bag): void {
  w.charatFinishHost = {
    saveText: function () {
      return c.saveChara();
    },
    carryText: function () {
      return c.saveChara(c.ATTR_AUTOSAVEKEY);
    },
    get font() {
      return c.FONT_CR ? c.FONT_CR : '';
    },
    composite: function () {
      return cm.lastComposite || null;
    },
    unzip: function (aText: string) {
      return cm.zipStrToStr(aText);
    },
    restore: function (aChara: unknown) {
      Array.prototype.forEach.call(document.querySelectorAll(c.DIV_F_RESTORE), function (el: HTMLElement) {
        el.style.display = 'none';
      });
      cm.setNowMaking(true, 1, 0, 0, c.DIV_F_CONTENTS);
      cm.setNowMaking(false, 1, 1200, 300, c.DIV_F_CONTENTS);
      c.makeCharactor(aChara, false, true);
    },
    closeRestore: function () {
      w.charat.sel.select('#' + c.btnRestore.ID + 'click').on('click')({ BTN: c.btnRestore });
    },
    carryIn: function (aZip: string) {
      cm.setStrage(c.ATTR_AUTOSAVEKEY, encodeURIComponent(aZip));
    },
    move: function (dx: number, dy: number) {
      if (c.selCategory.IS_MOVE == 3) {
        cm.moveG(c.svgMake, c.selCategory, c.ATTR_LAYER, dx, dy, 0, 0, 0, 0, c.scMake.x, c.scMake.y, c.SIZE_CHARAT_IMAGE);
      }
    },
    moveEnd: function () {
      cm.afterChangeTransform();
    },
    isJapanese: function () {
      return w.charat.IsJapanese();
    },
  };
}
